import BossModel from "@/models/BossModel";
import Party from "@/models/PhoneCall/Party/Party";
import User from "@/models/User/User";

export default class PhoneSms extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'phone-sms';

    /**
     *
     * @type {string}
     */
    static entity = 'phonesmses';

    static fields() {
		return {
			id: this.attr(null),
			message: this.attr(null),
            send_state_cid_name: this.attr(null),
			user_id: this.attr(null),
			dossier_id: this.attr(null),
			to_party_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            to: this.belongsTo(Party, 'to_party_id'),
            user: this.belongsTo(User, 'user_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    To() {
        return this.getRelated('to');
    }

    /**
     *
     * @returns {boolean|*}
     */
    User() {
        this.getRelated('user');
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .with([
                'to',
                'to.customer',
                'user'
            ])
            .get(true);
    }
}
